import { useParams } from "react-router";
import { useGetOneOrganization } from "src/api/client-api/company/useGetOneOrganization.ts";
import { CompanyCreate } from "./CompanyCreate";
import { useQueryClient } from "react-query";
import { useEffect } from "react";

type CompanyEditProps = {
    isProvider?: boolean;
};
export const CompanyEdit = (props: CompanyEditProps) => {
    const { id } = useParams();
    const queryClient = useQueryClient();

    // Temporarily invalidate cache to force fresh data
    useEffect(() => {
        if (id) {
            queryClient.invalidateQueries(["getOneCompany", id]);
        }
    }, [id, queryClient]);

    const { company, error, isLoading } = useGetOneOrganization({
        companyId: id,
    });

    if (isLoading) {
        return "Loading...";
    }

    if (error) {
        return `Error: ${error}`;
    }

    if (company === undefined) {
        return "Company not found";
    }

    return <CompanyCreate isProvider={props.isProvider} company={company} />;
};
